import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getMunicipalitiesWithRegionsList,
  createMunicipalityWithRegion,
  updateMunicipalityWithRegion,
  removeMunicipality,
} from 'services/api';
import type { RootState } from 'shared/services/redux/types';
import type {
  MunicipalitiesListRequest,
  CreateMunicipalityBody,
  UpdateMunicipalityBody,
} from 'services/api';

export const getMunicipalitiesListAction = createAsyncThunk(
  'municipalities/getList',
  async (params: MunicipalitiesListRequest) => {
    try {
      return await getMunicipalitiesWithRegionsList(params);
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);

export const createMunicipalityAction = createAsyncThunk(
  'municipalities/create',
  async (body: CreateMunicipalityBody) => {
    try {
      return await createMunicipalityWithRegion(body);
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);

export const updateMunicipalityAction = createAsyncThunk(
  'municipalities/update',
  async (body: UpdateMunicipalityBody, thunkApi) => {
    const {
      municipalitiesState: { selectedMunicipality },
    } = thunkApi.getState() as RootState;
    try {
      return await updateMunicipalityWithRegion(selectedMunicipality!.id, body);
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);

export const removeMunicipalityAction = createAsyncThunk(
  'municipalities/remove',
  async (municipalityId: number) => {
    try {
      await removeMunicipality(municipalityId);
      return municipalityId;
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);
